/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

import * as React from 'react';

const OuiIconLogoGolang = ({ title, titleId, ...props }) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M4.315 17.301c.045.946 1 .5 1.416.21.415-.29.5-.045.56-.6a9.07 9.07 0 00.045-1.09 2.676 2.676 0 00-1.786.455c-.26.19-.745.79-.24 1"
      fill="#F6D2A2"
    />
    <path
      d="M4.805 17.987a.6.6 0 01-.27-.06.62.62 0 01-.31-.55A.41.41 0 014 17.05a1.15 1.15 0 01.5-.83 2.752 2.752 0 011.846-.47h.075v.074c.01.286.003.572-.025.856v.25c-.025.39-.1.45-.3.5a1.118 1.118 0 00-.3.145c-.288.223-.63.364-.99.41zm1.271-2.067a2.502 2.502 0 00-1.47.45 1 1 0 00-.42.671.25.25 0 00.17.205h.05v.055a.5.5 0 00.21.45 1.31 1.31 0 001.065-.31 1.29 1.29 0 01.34-.17c.13-.045.16-.055.18-.365v-.25c.024-.25.034-.5.03-.75h-.155v.014z"
      fill="#010101"
    />
    <path d="M4.315 17.3a.745.745 0 00.376-.21z" fill="#C7B199" />
    <path
      d="M4.315 17.391a.092.092 0 11-.055-.175h.06a.54.54 0 00.275-.16.092.092 0 01.06-.035.09.09 0 01.068.017.09.09 0 01.035.06.091.091 0 01-.018.068.7.7 0 01-.36.22h-.065v.005z"
      fill="#010101"
    />
    <path
      d="M6.496 6.05C2.88 5.049 5.571.43 8.498 2.322L6.496 6.05z"
      fill="#74CDDD"
    />
    <path
      d="M6.541 6.154h-.07c-1.03-.29-1.666-.9-1.786-1.716a2.396 2.396 0 011.116-2.26 2.421 2.421 0 012.722.09l.07.044L6.54 6.154zm.5-4.192c-.41 0-.811.12-1.155.345A2.211 2.211 0 004.85 4.393c.11.726.67 1.276 1.586 1.551l1.901-3.587a2.501 2.501 0 00-1.28-.38l-.015-.015z"
      fill="#010101"
    />
    <path
      d="M22.566 1.977c2.862-2.001 5.448 2.502 2.121 3.667l-2.121-3.667z"
      fill="#74CDDD"
    />
    <path
      d="M24.647 5.754l-2.201-3.802.065-.045a2.362 2.362 0 012.626-.22 2.427 2.427 0 011.196 2.241c-.05.5-.32 1.356-1.616 1.801l-.07.025zm-1.961-3.752l2.041 3.532a1.956 1.956 0 001.426-1.62 2.24 2.24 0 00-1.106-2.077 2.126 2.126 0 00-2.361.165z"
      fill="#010101"
    />
    <path
      d="M23.181 28.928c.726.45 2.056 1.811.966 2.471-1.046.961-1.636-1.055-2.557-1.33a2.549 2.549 0 011.591-1.141z"
      fill="#F6D2A2"
    />
    <path
      d="M23.592 31.745h-.04c-.416-.025-.756-.43-1.086-.816a2.33 2.33 0 00-.9-.775l-.12-.035.074-.125a2.656 2.656 0 011.646-1.176h.065c.466.29 1.426 1.13 1.421 1.891a.835.835 0 01-.45.725.905.905 0 01-.61.31zm-1.861-1.721c.339.2.633.467.865.785.219.36.56.628.96.755a.716.716 0 00.5-.235.661.661 0 00.371-.58c0-.61-.77-1.376-1.306-1.721a2.351 2.351 0 00-1.386.996h-.005z"
      fill="#010101"
    />
    <path
      d="M24.147 31.494a.09.09 0 01-.08-.05c-.053-.11-.1-.224-.14-.34a1.5 1.5 0 00-.33-.61.091.091 0 01-.022-.098.09.09 0 01.147-.032c.172.188.3.414.37.66.039.11.084.216.135.32a.09.09 0 01-.04.12l-.04.03z"
      fill="#010101"
    />
    <path
      d="M10.189 30.464c-.856.13-1.336.9-2.046 1.29a.62.62 0 01-1.001-.235.325.325 0 01-.26-.12c-.62-1 .645-1.696 1.31-2.186.936-.18 1.511.615 1.997 1.25z"
      fill="#F6D2A2"
    />
    <path
      d="M7.692 31.995a.613.613 0 01-.16 0 .74.74 0 01-.435-.375.301.301 0 01-.245-.13c-.6-.946.42-1.662 1.096-2.137l.235-.17c.945-.19 1.546.59 2.026 1.22l.135.181h-.15a2.586 2.586 0 00-1.266.725c-.23.212-.482.4-.75.56a1.001 1.001 0 01-.486.126zm-.6-.58a.245.245 0 01.105 0h.025l.04.08a.58.58 0 00.335.305.686.686 0 00.5-.12c.26-.155.503-.337.726-.54a3 3 0 011.206-.736c-.46-.6-1-1.25-1.786-1.1l-.225.16c-.69.5-1.546 1.09-1.051 1.885a.146.146 0 00.105.07l.02-.005z"
      fill="#010101"
    />
    <path
      d="M7.157 31.614a.09.09 0 01-.09-.12c.037-.24.137-.466.29-.655.072-.1.136-.205.19-.315a.09.09 0 11.165.075c-.058.12-.127.236-.205.345-.132.17-.217.372-.245.585a.09.09 0 01-.067.084.09.09 0 01-.038.002zM6.647 4.78c-.5-.25-.826-.596-.536-1.146.29-.55.77-.455 1.251-.205l-.715 1.35zm17.285-.48c.5-.25.825-.596.535-1.146-.29-.55-.77-.456-1.25-.205l.715 1.35z"
      fill="#010101"
    />
    <path
      d="M27.219 17.181c-.045.946-1.001.5-1.416.21-.416-.29-.5-.045-.56-.6a9.068 9.068 0 01-.046-1.09 2.677 2.677 0 011.787.454c.26.19.745.79.24 1.001"
      fill="#F6D2A2"
    />
    <path
      d="M26.728 17.846a2.046 2.046 0 01-.955-.36 1.117 1.117 0 00-.3-.145c-.2-.07-.275-.13-.3-.5v-.25a6.516 6.516 0 01-.026-.856v-.12h.076a2.751 2.751 0 011.846.47 1.15 1.15 0 01.5.83.412.412 0 01-.225.326.62.62 0 01-.31.55.605.605 0 01-.306.055zm-1.456-2.06c-.003.25.007.5.03.75v.25c0 .305.046.315.18.365.122.04.236.097.34.17a1.307 1.307 0 001.067.31.502.502 0 00.21-.45v-.06h.05a.25.25 0 00.17-.205 1.002 1.002 0 00-.42-.67 2.552 2.552 0 00-1.627-.46z"
      fill="#010101"
    />
    <path d="M27.218 17.181a.746.746 0 01-.375-.195z" fill="#C7B199" />
    <path
      d="M27.219 17.271h-.095a.7.7 0 01-.35-.25.09.09 0 01-.007-.101.091.091 0 01.152-.01.54.54 0 00.275.16h.06a.101.101 0 11-.035.201z"
      fill="#010101"
    />
    <path
      d="M15.407.066c3.622 0 7.004.5 8.785 4.002 1.586 3.898 1 8.105 1.266 12.223.21 3.537.67 7.624-.97 10.906-1.717 3.442-6.05 4.297-9.601 4.182-2.792-.1-6.164-1-7.74-3.562-1.851-3.002-.976-7.444-.84-10.771.16-3.942-1.071-7.9.225-11.762C7.877 1.282 11.5.376 15.402.066"
      fill="#74CDDD"
    />
    <path
      d="M15.502 31.494h-.62a13.202 13.202 0 01-4.358-.87 6.969 6.969 0 01-3.457-2.737c-1.501-2.421-1.23-5.763-1-8.715.06-.74.114-1.446.14-2.106.026-1.4-.034-2.8-.18-4.192-.211-2.502-.431-5.089.41-7.595a6.644 6.644 0 013.501-4.047C11.29.572 12.94.19 15.367 0c3.572-.025 7.094.475 8.905 4.022 1.16 2.852 1.176 5.914 1.196 8.876 0 1.11 0 2.256.08 3.377 0 .34.04.685.065 1.03.21 3.247.45 6.934-1.046 9.916-1.871 3.732-6.574 4.272-9.065 4.272zM15.407.156c-3.768.32-7.44 1.13-8.79 5.158-.831 2.471-.61 5.038-.406 7.504.147 1.4.207 2.806.18 4.213-.025.665-.085 1.37-.14 2.116-.23 2.922-.5 6.239.966 8.605.615 1 2.596 3.337 7.67 3.502 2.196.08 7.504-.17 9.505-4.142 1.47-2.942 1.236-6.599 1.026-9.826 0-.35-.045-.695-.065-1.03a67.451 67.451 0 01-.08-3.353c0-2.941-.03-6.003-1.181-8.805A6.438 6.438 0 0020.445.841a14.96 14.96 0 00-5.038-.685z"
      fill="#010101"
    />
    <path
      d="M16.042 4.924c.65 3.777 6.824 2.781 5.938-1.03-.795-3.418-6.153-2.472-5.938 1.03z"
      fill="#fff"
    />
    <path
      d="M18.979 7.39a3.457 3.457 0 01-1.13-.185 2.797 2.797 0 01-1.892-2.266 2.882 2.882 0 01.78-2.222 3.407 3.407 0 012.002-1 3.202 3.202 0 012.031.35 2.727 2.727 0 011.296 1.806 2.643 2.643 0 01-.77 2.682 3.502 3.502 0 01-2.317.835zm-2.847-2.476a2.626 2.626 0 001.776 2.126 3.417 3.417 0 003.277-.62 2.502 2.502 0 00.716-2.502 2.672 2.672 0 00-3.132-2.031 2.887 2.887 0 00-2.637 3.027z"
      fill="#010101"
    />
    <path
      d="M8.663 5.539c.84 3.287 6.103 2.441 5.908-.855-.235-3.953-6.714-3.207-5.908.855z"
      fill="#fff"
    />
    <path
      d="M11.474 7.705a3.232 3.232 0 01-1.536-.375 2.727 2.727 0 01-1.355-1.776 2.757 2.757 0 01.94-2.827 3.552 3.552 0 013.532-.45 2.672 2.672 0 011.601 2.402c.105 1.75-1.286 2.771-2.617 3.001a3.657 3.657 0 01-.565.025zM8.763 5.52A2.732 2.732 0 0012.03 7.52c1.26-.2 2.576-1.16 2.476-2.806a2.501 2.501 0 00-1.5-2.262 3.377 3.377 0 00-3.358.43 2.597 2.597 0 00-.885 2.637z"
      fill="#010101"
    />
    <path
      d="M16.767 9.481c.049.521.049 1.046 0 1.566a1 1 0 01-.585.36.861.861 0 01-.655-.5c-.032-.59-.017-1.183.045-1.77l1.195.344z"
      fill="#fff"
    />
    <path
      d="M16.237 11.483h-.025a.944.944 0 01-.725-.566 5.95 5.95 0 010-1.215c0-.185.03-.38.035-.57v-.15l1.35.414v.085c0 .16 0 .33.026.5.045.358.045.72 0 1.076v.025a.75.75 0 01-.476.34l-.155.06h-.03zm-.58-.63a.766.766 0 00.56.445l.14-.056a.6.6 0 00.366-.26c.04-.332.04-.668 0-1 0-.155 0-.305-.026-.455l-1-.306c0 .155 0 .31-.03.46-.044.388-.05.778-.015 1.166l.005.005zM10.114 5.964c.491 0 .89-.432.89-.965 0-.534-.399-.966-.89-.966-.492 0-.89.432-.89.966 0 .533.398.965.89.965z"
      fill="#010101"
    />
    <path
      d="M10.519 5.464c.116 0 .21-.11.21-.245s-.094-.245-.21-.245c-.116 0-.21.11-.21.245s.094.245.21.245z"
      fill="#fff"
    />
    <path
      d="M17.568 5.724c.483 0 .875-.432.875-.965 0-.533-.392-.966-.875-.966-.484 0-.876.433-.876.966 0 .533.392.965.876.965z"
      fill="#010101"
    />
    <path
      d="M17.963 5.224c.114 0 .206-.11.206-.245 0-.136-.092-.245-.206-.245-.113 0-.205.11-.205.245s.092.245.205.245zM14.266 9.406c-.39.941.215 2.822 1.27 1.436a11.12 11.12 0 01.046-1.77l-1.316.334z"
      fill="#fff"
    />
    <path
      d="M14.812 11.428a.5.5 0 01-.26-.07c-.426-.246-.691-1.251-.39-2.002v-.04l1.5-.38v.12c0 .195 0 .39-.035.575a5.71 5.71 0 000 1.181v.065a1.056 1.056 0 01-.815.55zm-.496-1.947c-.215.586-.045 1.501.33 1.716.27.155.57-.115.78-.385a6.128 6.128 0 010-1.18c0-.146 0-.3.031-.45l-1.14.3z"
      fill="#010101"
    />
    <path
      d="M14.38 7.595a1.146 1.146 0 00-.94 1.601c.5.9 1.611-.08 2.302 0 .795 0 1.45.84 2.09.15.711-.77-.304-1.5-1.1-1.856l-2.351.105z"
      fill="#F6D2A2"
    />
    <path
      d="M17.268 9.727a2 2 0 01-.73-.206 2.207 2.207 0 00-.791-.22c-.287 0-.57.062-.83.18-.561.195-1.196.416-1.557-.23a1.08 1.08 0 010-1.05 1.281 1.281 0 011.001-.686l2.406-.105c.59.25 1.266.706 1.381 1.236a.955.955 0 01-.88 1.08zm-1.501-.606c.296.024.584.104.85.235.45.19.806.335 1.166-.055a.664.664 0 00.205-.605c-.1-.46-.735-.88-1.256-1.1l-2.326.094a1.11 1.11 0 00-.85.59.906.906 0 000 .876c.285.5.795.335 1.34.15.274-.122.57-.185.87-.185z"
      fill="#231F20"
    />
    <path
      d="M14.266 7.56c-.055-1.25 2.336-1.41 2.617-.36.28 1.05-2.502 1.29-2.617.36z"
      fill="#010101"
    />
  </svg>
);

export const icon = OuiIconLogoGolang;
